(ns router.specs
  (:require [cljs.spec.alpha :as s]
            [very.re-frame.specs :as reframe]))

(s/def ::redirects keyword?)
(s/def ::on-enter ::reframe/dispatch-vector)
(s/def ::route (s/keys :opt-un [::redirects
                                ::on-enter]))
(s/def ::authenticated (s/map-of keyword? ::route))
(s/def ::unauthenticated (s/map-of keyword? ::route))
(s/def ::routes (s/keys :req-un [::authenticated
                                 ::unauthenticated]))
(s/def ::current keyword?)
(s/def ::route-table (s/keys :req-un [::routes
                                      ::current]))
(s/def ::routable-path (s/or :path string?
                             :special-case #{:kill}))
